import * as React from 'react';
/**
 * @ignore - internal component.
 */

var ButtonGroupContext =
/*#__PURE__*/
React.createContext({});

if (process.env.NODE_ENV !== 'production') {
  ButtonGroupContext.displayName = 'ButtonGroupContext';
}

export default ButtonGroupContext;